import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { TeamType } from "@common/ADAPT.Common.Model/organisation/team-type";
import { ImplementationKitArticle } from "@common/implementation-kit/implementation-kit-article.enum";
import { IConfigGroup } from "@org-common/lib/configuration/configuration.interfaces";
import { ConfigurationAuthService } from "@org-common/lib/configuration/configuration-auth.service";
import { ConfigArea } from "@org-common/lib/configuration/configuration-types";
import { CommonTeamsAuthService } from "@org-common/lib/teams/common-teams-auth.service";

export const allTeamConfigGroups = (): IConfigGroup[] => [
    {
        key: "Group",
        items: [
            {
                name: "Profile",
                area: ConfigArea.TeamProfile,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
            },
            {
                name: "Appearance",
                area: ConfigArea.TeamAppearance,
                accessVerifier: ConfigurationAuthService.ConfigureOrganisation,
                nonTeamAccessVerifier: true,
            },
            {
                name: "People",
                area: ConfigArea.People,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
            },
            {
                name: "External links",
                area: ConfigArea.ExternalLink,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.OrganisationExternalDashboard,
                enableFeatureText: "external links",
            },
            {
                name: "Objectives & key results",
                area: ConfigArea.ObjectivesAndKeyResults,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.StewardshipObjectives,
                enableFeatureText: "objectives & key results",
                supportArticleId: ImplementationKitArticle.IntroducingObjectivesAndKeyResults,
                supportText: "Find out more about objectives on the Adapt support site.",
            },
            {
                name: "Owners vision",
                area: ConfigArea.OwnersVision,
                featureName: FeatureName.CompassVision,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                matchTeamType: TeamType.Owner,
                enableFeatureText: "owners vision",
            },
            {
                name: "Values",
                area: ConfigArea.ValuesConstitution,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.CompassValuesConstitution,
                enableFeatureText: "values",
                supportArticleId: ImplementationKitArticle.ValuePurposeVision,
                supportText: "Find out more about values and value constitutions on the Adapt support site.",
            },
            {
                name: "Actions",
                area: ConfigArea.Kanban,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.StewardshipWorkKanban,
                enableFeatureText: "actions",
                supportArticleId: ImplementationKitArticle.TeamStewardship,
                supportText: "Find out more about effective group stewardship on the Adapt support site.",
            },
            {
                name: "Meetings",
                area: ConfigArea.Meetings,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.StewardshipWorkMeetings,
                enableFeatureText: "meetings",
                supportArticleId: ImplementationKitArticle.TeamStewardship,
                supportText: "Find out more about effective group stewardship on the Adapt support site.",
            },
            {
                name: "Peer Catch-up",
                area: ConfigArea.PeerCatchUp,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.PeoplePeerCatchUp,
                supportArticleId: ImplementationKitArticle.PeerCatchUp,
                supportText: "Find out more about Peer Catch-ups on the Adapt support site.",
            },
            {
                name: "Team assessment",
                area: ConfigArea.TeamAssessment,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.CulturalNetworkTeamAssessment,
                enableFeatureText: "team assessment",
                supportArticleId: ImplementationKitArticle.UsingTheAdaptTeamModel,
                supportText: "Find out more about team assessment on the Adapt support site.",
            },
            {
                name: "Systems",
                area: ConfigArea.System,
                accessVerifier: CommonTeamsAuthService.ConfigureTeam,
                featureName: FeatureName.ArchitectureSystem,
                enableFeatureText: "systems",
                supportArticleId: ImplementationKitArticle.SystemiseYourBusiness,
                supportText: "Find out more about systems & processes (systems & guidance materials) on the Adapt support site.",
            },
            {
                name: "Access permissions",
                area: ConfigArea.AccessPermissions,
                accessVerifier: CommonTeamsAuthService.ViewTeamAccessPermissions,
            },
        ],
    },
];
